import { module as BaseModule } from 'modujs'

import 'lite-youtube-embed'
import 'lite-youtube-embed/src/lite-yt-embed.css'

export default class extends BaseModule {
  init () {
    this.options = {
      muted: true,
      loop: true,
      controls: false,
      soundLevel: 0.5
    }

    this.iframe = this.el.querySelector('lite-youtube')
    this.container = this.el
    this.isInit = false
    this.isPlaying = false
    this.isLoaded = false
    this.isFullscreen = false
    this.isDebugging = true
    this.isMuted = this.options.muted
    this.id = this.iframe ? this.iframe.getAttribute('videoid') : null

    if (!this.iframe) {
      console.warn('Missing required arguements, abording YT initializer') // eslint-disable-line
    }

    this.initialize()
  }

  debugger (...log) {
    if (this.isDebugging)
      console.log({
        ...log
      }) //eslint-disable-line
  }

  async initialize () {
    this.debugger(this.id, 'initialize')
    this.playBtns = this.container.querySelectorAll('.js-play')
    this.pauseBtns = this.container.querySelectorAll('.js-pause')
    this.mute = this.container.querySelector('.js-toggle-mute')
    this.area = this.container.querySelector('.c-player__clickable')
    this.progress = this.container.querySelector('.c-player__progress')

    this.player = await this.iframe.getYTPlayer()
    this.debugger(this.id, 'YT loaded')

    this.player.mute()
    this.player.setLoop(this.options.loop)
    this.container.classList.add('is-loaded')
    this.isInit = true
    this.isLoaded = true
    this.duration = await this.player.getDuration()
    this.on()

    this.player.addEventListener('onStateChange', ({ data }) => {
      this.debugger(this.id, 'stateChange', data)

      //  -1 (unstarted)
      // 0 (ended)
      // 1 (playing)
      // 2 (paused)
      // 3 (buffering)
      // 5 (video cued).

      switch (data) {
        case 1:
          this.isPlaying = true
          this.container.classList.add('is-playing')
          this.debugger(this.id, 'playing')
          this.trackProgress()
          break
        case 2:
          this.isPlaying = false
          this.container.classList.remove('is-playing')
          this.debugger(this.id, 'playing')
          this.stopProgress()
          break
        case 0:
          this.debugger(this.id, 'ended')
          if (this.options.loop) this.player.seekTo(0)
          break
        default:
          break
      }
    })

    this.player.playVideo()
  }

  on () {
    this.playHandler = () => {
      this.hasUserInteracted = true
      this.play()
    }
    this.pauseHandler = () => {
      this.hasUserInteracted = true
      this.pause()
    }
    this.togglePlayHandler = () => {
      this.hasUserInteracted = true
      this.togglePlay()
    }

    this.muteHandler = () => this.toggleMute()

    this.progressClickHander = e => {
      const { target } = e
      const bounds = target.getBoundingClientRect()
      const max = bounds.width
      const pos = e.pageX - bounds.left
      const percentage = Math.round((pos / max) * 100)
      this.goTo(percentage)
    }

    this.playBtns.forEach(btn => {
      btn.addEventListener('click', this.playHandler)
    })
    this.pauseBtns.forEach(btn => {
      btn.addEventListener('click', this.pauseHandler)
    })

    this.mute.addEventListener('click', this.muteHandler)
    this.progress.addEventListener('click', this.progressClickHander)
    this.area.addEventListener('click', this.togglePlayHandler)
  }

  goTo (percentage) {
    try {
      const time = (percentage / 100) * this.duration
      this.player.seekTo(time)
      if (!this.isPlaying) this.updateProgress(time)
    } catch (error) {
      throw new Error(`Goto – ${error}`)
    }
  }

  async toggleMute () {
    this.container.classList.toggle('is-unmute')
    if (this.isMuted) {
      await this.player.setVolume(this.options.soundLevel)
      await this.player.unMute()
      this.isMuted = false
    } else {
      await this.player.mute()
      this.isMuted = true
    }
  }

  togglePlay () {
    if (this.isPlaying) {
      this.pause()
    } else {
      this.play()
    }
  }

  async play () {
    try {
      this.debugger(this.id, 'play', this.isPlaying)
      if (this.isPlaying === false) {
        this.playbackPromise = this.player.playVideo()
      }
    } catch (error) {
      throw new Error(`Play – ${error}`)
    }
  }

  async pause () {
    try {
      this.debugger(this.id, 'pause function', this.isPlaying)
      if (this.isPlaying === false) return
      this.debugger(this.id, 'pause exectued', this.isPlaying)
      await this.playbackPromise
      this.player.pauseVideo()
    } catch (error) {
      throw new Error(`Pause – ${error}`)
    }
  }

  async updateProgress (duration) {
    try {
      duration = Number(duration)
      const progress = duration / this.duration
      this.progress.style.setProperty('--progress', progress)
    } catch (error) {
      throw new Error(`updateProgress – ${error}`)
    }
  }

  async getCurrentTime () {
    try {
      if (this.isInit === false) return
      const time = await this.player.getCurrentTime()
      this.updateProgress(time)
    } catch (error) {
      throw new Error(`getCurrentTime – ${error}`)
    }
  }

  trackProgress () {
    this.interval = setInterval(this.getCurrentTime.bind(this), 100)
  }

  stopProgress () {
    clearInterval(this.interval)
  }
}
